import { SEO } from "@/components/SEO";
import { PageHead, Panel } from "@/components/Panel";
import { Reveal } from "@/components/Reveal";

export const Privacy = () => (
  <div data-testid="privacy-page">
    <SEO
      title="Privacy Policy | RevGen Genius"
      description="How RevGen Genius collects, uses, and protects your information."
      path="/privacy"
    />
    <div className="mx-auto max-w-[900px] space-y-16 px-5 sm:px-8">
      <PageHead testId="privacy-head" label="Legal" title="Privacy Policy" />
      <Reveal>
        <Panel className="space-y-5 !border-[#D7E3FB] pt-8 leading-relaxed text-[#5B6784]">
          <p className="text-sm font-medium text-[#5B6784]">Last updated: 18 August 2026</p>
          <p>
            RevGen Genius collects only the information you choose to share with us through our
            contact and booking forms: your name, work email, company, role, company size, and the
            message you send.
          </p>
          <p>
            We use that information for one purpose: to respond to your enquiry and prepare for
            your assessment. We do not sell, rent, or share your information with third parties,
            and we do not use it for marketing lists you did not ask to join.
          </p>
          <p>
            You can ask us to correct or delete your information at any time by writing to
            info@revgengenius.com.
          </p>
        </Panel>
      </Reveal>

      <Reveal>
        <Panel label="Cookies" className="space-y-6 !border-[#D7E3FB] pt-14 leading-relaxed text-[#5B6784]">
          <p>
            We do not use advertising or analytics cookies. The only cookies set on this site come
            from Cal.com, the service that powers our booking calendar, and they exist to keep that
            booking process secure and working.
          </p>
          <div className="overflow-x-auto">
            <table className="w-full border-collapse text-left text-[0.95rem]" data-testid="cookie-table">
              <thead>
                <tr className="border-b-[1.5px] border-[#1F5FFF]">
                  <th scope="col" className="py-3 pr-6 font-heading font-semibold text-[#0A1F44]">Cookie</th>
                  <th scope="col" className="py-3 pr-6 font-heading font-semibold text-[#0A1F44]">Set by</th>
                  <th scope="col" className="py-3 font-heading font-semibold text-[#0A1F44]">Purpose</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-[#EAF1FF] align-top">
                  <td className="py-4 pr-6 font-mono text-sm text-[#17203A]">__cf_bm</td>
                  <td className="py-4 pr-6">Cloudflare (via Cal.com)</td>
                  <td className="py-4">Security. Distinguishes real visitors from automated bots.</td>
                </tr>
                <tr className="border-b border-[#EAF1FF] align-top">
                  <td className="py-4 pr-6 font-mono text-sm text-[#17203A]">NextAuth CSRF</td>
                  <td className="py-4 pr-6">Cal.com</td>
                  <td className="py-4">Security. Prevents cross-site request forgery on the booking form.</td>
                </tr>
                <tr className="align-top">
                  <td className="py-4 pr-6 font-mono text-sm text-[#17203A]">NextAuth session</td>
                  <td className="py-4 pr-6">Cal.com</td>
                  <td className="py-4">Functional. Maintains your booking session while you pick a time.</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p>
            These are set only on our Contact page, where the booking calendar appears. No other
            page on this site loads anything from Cal.com. You can block or delete these cookies in
            your browser settings; the booking calendar will not work if you do.
          </p>
        </Panel>
      </Reveal>
    </div>
  </div>
);

export const Terms = () => (
  <div data-testid="terms-page">
    <SEO
      title="Terms of Service | RevGen Genius"
      description="The terms that govern use of the RevGen Genius website."
      path="/terms"
    />
    <div className="mx-auto max-w-[900px] space-y-16 px-5 sm:px-8">
      <PageHead testId="terms-head" label="Legal" title="Terms of Service" />
      <Reveal>
        <Panel className="space-y-5 !border-[#D7E3FB] pt-8 leading-relaxed text-[#5B6784]">
          <p>
            The content on this website is provided for general information about RevGen Genius
            and our services. It does not constitute professional advice, and no client
            relationship is formed by using this site or submitting a form.
          </p>
          <p>
            All content, branding, and materials on this site are the property of RevGen Genius
            and may not be reproduced without written permission.
          </p>
          <p>
            Engagement terms, deliverables, and commercial conditions are defined in individual
            statements of work agreed with each client.
          </p>
        </Panel>
      </Reveal>
    </div>
  </div>
);
